export const getCourseImage = (course) => {
    if (!course) return "/images/placeholder.png";

    const title = course.title?.toLowerCase() || "";
    const slug = course.slug?.toLowerCase() || "";
    const currentImg = course.image_url || "";

    // Priority mapping for our brand new premium banners
    if (title.includes("react") || slug.includes("react")) return "/images/react_banner.png";
    if (title.includes("python") || slug.includes("python")) return "/images/python_banner.png";
    if (title.includes("fastapi") || slug.includes("fastapi")) return "/images/fastapi_banner.png";
    if (title.includes("javascript") || slug.includes("javascript") || slug.includes("js")) return "/images/javascript_banner.png";
    if (title.includes("html") || title.includes("css") || slug.includes("html") || slug.includes("css")) return "/images/html_css_banner.png";
    if (title.includes("sql") || slug.includes("sql")) return "/images/sql_banner.png";
    if (title.includes("ruby") || slug.includes("ruby")) return "/images/ruby_banner.png";
    if (title.includes("lua") || slug.includes("lua")) return "/images/lua_banner.png";
    if (title.includes("agentic") || title.includes("ai agent") || slug.includes("agentic")) return "/images/agentic_ai_banner.png";
    if (title.includes("dsa") || title.includes("data structures") || slug.includes("dsa")) return "/images/dsa_banner.png";
    if (title.includes("gen") || title.includes("generative") || slug.includes("genai")) return "/images/gen_ai_banner.png";

    // Fallback to provided image if it's not a placeholder
    if (currentImg && !currentImg.includes("placeholder")) {
        return currentImg;
    }

    return "/images/placeholder.png";
};
